import { resolveRuntimeWindow } from '@/lib/utils/runtime-window';

const OFFLINE_MODE_STORAGE_KEY = 'sweetistics.offlineMode';
const OFFLINE_MODE_EVENT = 'sweetistics:offline-mode';

export function readOfflineModeFlag(): boolean {
  const runtimeWindow = resolveRuntimeWindow();
  if (!runtimeWindow) {
    return false;
  }
  try {
    return runtimeWindow.localStorage.getItem(OFFLINE_MODE_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function notifyOfflineModeChanged(): void {
  const runtimeWindow = resolveRuntimeWindow();
  if (!runtimeWindow) {
    return;
  }
  runtimeWindow.dispatchEvent(new CustomEvent(OFFLINE_MODE_EVENT));
}

export function subscribeOfflineMode(listener: () => void): () => void {
  const runtimeWindow = resolveRuntimeWindow();
  if (!runtimeWindow) {
    return () => {
      // No-op when window is unavailable.
    };
  }
  const handleStorage = (event: StorageEvent) => {
    if (event.key === null || event.key === OFFLINE_MODE_STORAGE_KEY) {
      listener();
    }
  };
  const handleCustom = () => {
    listener();
  };

  runtimeWindow.addEventListener('storage', handleStorage);
  runtimeWindow.addEventListener(OFFLINE_MODE_EVENT, handleCustom);

  return () => {
    runtimeWindow.removeEventListener('storage', handleStorage);
    runtimeWindow.removeEventListener(OFFLINE_MODE_EVENT, handleCustom);
  };
}

export { OFFLINE_MODE_EVENT, OFFLINE_MODE_STORAGE_KEY };
